/* istanbul ignore file */
import ShortFormPlain from "./ShortFormPlain.module.scss";
import ShortFormMobile from "./ShortFormMobile.module.scss";

export default {
  ShortFormPlain,
  ShortFormMobile,
};
